import config from "../config";
import { getById } from "../contexts/apicontexts";

const LS_MENU = "menuItems";
const LS_MENU_AT = "menuItemsFetchedAt";
const REFRESH_MS = 10 * 60 * 1000; // 10 minutes

export const getCachedMenuItems = () => {
  try {
    const raw = localStorage.getItem(LS_MENU);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const isMenuCacheFresh = () => {
  const at = Number(localStorage.getItem(LS_MENU_AT) || 0);
  return at > 0 && Date.now() - at < REFRESH_MS;
};

export const fetchAndCacheMenuItems = async (userId) => {
  const url = userId
    ? `${config.baseurl}MenuPermission/menuItems?userId=${userId}`
    : `${config.baseurl}MenuPermission/menuItems`;

  const res = await getById(url);
  console.log("res", res);
  if (res?.status === 200 && res?.data) {
    localStorage.setItem(LS_MENU, JSON.stringify(res.data));
    localStorage.setItem(LS_MENU_AT, String(Date.now()));
    return res.data;
  }
  return null;
};

export const startMenuAutoRefresh = (userId, onUpdate) => {
  const tick = async () => {
    try {
      const data = await fetchAndCacheMenuItems(userId);
      if (data && typeof onUpdate === "function") onUpdate(data);
    } catch {
      // ignore
    }
  };

  const id = setInterval(tick, REFRESH_MS);
  return () => clearInterval(id);
};

